/**
 * Icon component.
 */

/** Dependencies -------------------------------------------- */

// External

import classNames from 'classnames';

// Design system

import AlertSvg from '../../../img/svg/alert.svg';
import ArrowUpSvg from '../../../img/svg/arrow-up.svg';
import ArrowRightSvg from '../../../img/svg/arrow-right.svg';
import ArrowDownSvg from '../../../img/svg/arrow-down.svg';
import ArrowLeftSvg from '../../../img/svg/arrow-left.svg';
import CloseSvg from '../../../img/svg/close.svg';
import DownloadCloudSvg from '../../../img/svg/download-cloud.svg';
import InfoSvg from '../../../img/svg/info.svg';
import MinusSvg from '../../../img/svg/minus.svg';
import PlusSvg from '../../../img/svg/plus.svg';
import QuestionSvg from '../../../img/svg/question.svg';

// Brand-specific

import DevelopmentTypeAdministrationSvg from '../../../img/svg/_development-type-administration.svg';
import DevelopmentTypeInformationSvg from '../../../img/svg/_development-type-information.svg';
import DevelopmentTypeInterferenceSvg from '../../../img/svg/_development-type-interference.svg';
import DevelopmentTypeViolenceSvg from '../../../img/svg/_development-type-violence.svg';

/** Constants ----------------------------------------------- */

const baseClassName = 'c-icon';

/** Functions ----------------------------------------------- */

function getSpecimenProps( type ) {

   let Specimen
   let width = 32
   let height = 32

   switch ( type ) {

      // Design system

      case 'alert':
         Specimen = AlertSvg
         break

      case 'arrowUp':
         Specimen = ArrowUpSvg
         break

      case 'arrowRight':
         Specimen = ArrowRightSvg
         break

      case 'arrowDown':
         Specimen = ArrowDownSvg
         break

      case 'arrowLeft':
         Specimen = ArrowLeftSvg
         break

      case 'close':
            Specimen = CloseSvg
            break

      case 'downloadCloud':
         Specimen = DownloadCloudSvg
         break

      case 'info':
         Specimen = InfoSvg
         break

      case 'minus':
         Specimen = MinusSvg
         break

      case 'plus':
         Specimen = PlusSvg
         break

      case 'question':
         Specimen = QuestionSvg
         break

      // Brand-specific

      case 'developmentTypeAdministration':
         Specimen = DevelopmentTypeAdministrationSvg
         break

      case 'developmentTypeInformation':
         Specimen = DevelopmentTypeInformationSvg
         break

      case 'developmentTypeInterference':
         Specimen = DevelopmentTypeInterferenceSvg
         break

      case 'developmentTypeViolence':
         Specimen = DevelopmentTypeViolenceSvg
         break
   }

   return {
      Specimen,
      aspectRatio: width / height
   }
}

/** Components ---------------------------------------------- */

export default function Icon( props ) {

   const { type, iconSize, className, children, ...additionalProps } = props;

   if ( ! type ) return

   const { Specimen, aspectRatio } = getSpecimenProps( type )

   const consolidatedClassName = classNames(
      baseClassName,
      {
         [`is-type-${type}`]: type,
         [`is-size-${iconSize}`]: iconSize,
      },
      className
   );

   return (
      <i role="presentation" className={ consolidatedClassName } style={ { aspectRatio: aspectRatio } } { ...additionalProps }>
         <Specimen className={ `${baseClassName}__specimen` }/>
         { children }
      </i>
   );
}
